<template>
    <div class="fixed z-index-fixed top-0 left-0 w-screen h-topbar" data-cy="container_top_bar">
        <div class="flex h-full" :class="topbarClass">
            <div class="flex justify-center w-full p-3 relative items-center">
                <div class="absolute left-0" :class="{ 'top-0': hasLogo && !hasNavBack }" data-cy="container_top_bar_left">
                    <template v-if="hasNavBack">
                        <button
                            class="outline-none appearance-none bg-transparent p-4 text-center"
                            @click="clickNavBack()"
                            data-cy="btn_top_bar_back"
                        >
                            <img src="@/assets/icons/arrow/arrow-left.svg" data-cy="icon_top_bar_back_arrow" />
                            <span class="sr-only">Back</span>
                        </button>
                    </template>
                    <template v-else-if="hasLogo">
                        <div class="ml-4">
                            <img src="@/assets/imgs/logo/KSAM_logo.png" class="logo" data-cy="img_top_bar_logo"/>
                        </div>
                    </template>
                </div>

                <div v-if="title != undefined" class="text-dark-1 font-medium font-main-medium" data-cy="text_top_bar_title">{{ title }}</div>
                <div class v-else data-cy="img_top_bar_iconic_wrap">
                    <img src="@/assets/imgs/topbar-iconic.svg" data-cy="img_top_bar_iconic" />
                </div>

                <div class="absolute right-1" data-cy="container_top_bar_right">
                    <template v-if="hasLangSwitcher">
                        <LangSwitcher data-cy="component_top_bar_lang_switcher"></LangSwitcher>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import Utility from "@/helper/Utility";

// components
import LangSwitcher from "./LangSwitcher.vue";

export default {
    name: "TopBar",
    mixins: [LocaleMixin],
    inject: ["SideMenuStore", "UserLevels"],
    props: {
        navBack: {
            type: [Boolean, Function],
            default: undefined
        },
        hasLangSwitcher: {
            type: Boolean,
            default: false
        },
        hasLogo: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: undefined
        }
    },
    data: function () {
        return {
            pageActive: this.$route.name,
            showLangSwitch: false,
        };
    },
    computed: {
        hasNavBack: function () {
            if (this.navBack != null && this.navBack != false) {
                return true;
            }
            return false;
        },
        topbarClass: function () {
            let cls = [];
            // // determine user level
            // let isGold = true;
            // if (this.$route.query.platinum != undefined) {
            //     isGold = false;
            // }
            if (this.UserLevels.isPlatinum) {
                cls.push("bg-platinum");
            }
            else if (this.UserLevels.isGold) {
                cls.push("bg-gold");
            }
            return cls;
        },
    },
    methods: {
        openSideMenu: function () {
            // this.$store.commit('openSideMenu');
            this.SideMenuStore.methods.open();
        },
        clickNavBack: function () {
            if (Utility.isFunction(this.navBack)) {
                this.navBack();
            }
            else {
                this.$router.go(-1);
            }
        },
        //#region lang btn
        toggleLangSwitch: function () {
            if (this.showLangSwitch) {
                this.closeLangMenu();
            }
            else {
                this.openLangMenu();
            }
        },
        openLangMenu: function () {
            this.showLangSwitch = true;
            document.addEventListener("click", this.documentClick);
        },
        closeLangMenu: function () {
            this.showLangSwitch = false;
            document.removeEventListener("click", this.documentClick);
        },
        documentClick: function (e) {
            var el = this.$refs["lang-menu"];
            var target = e.target;
            if (el !== target && !el.contains(target)) {
                this.closeLangMenu();
            }
        },
        clickSwitchLang: function (locale) {
            this.showLangSwitch = false;
            this.switchLang(locale);
        },
        //#endregion lang btn
    },
    components: { LangSwitcher }
}
</script>
<style lang="scss" scoped>
.logo {
    width: 36px;
    height: 60px;
}
</style>
